import { createButton } from '@archer-technologies/ui-components';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import * as React from 'react';

interface ToolbarDeletePluginProps {
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  translate: any;
}

const pluginDependencies = [{ name: 'Toolbar' }];

const ToolbarDelete = ({ onClick, disabled, translate }: ToolbarDeletePluginProps) => {
  return (
    <Plugin name="toolbarDeleteFilter" dependencies={pluginDependencies}>
      <Template name="toolbarContent">
        <TemplatePlaceholder />
        {createButton({
          type: 'DELETE',
          isIconButton: true,
          tooltipTitle: translate('rgrd:deleteButton'),
          actionType: 'primary',
          onClick,
          disabled,
          translate
        })}
      </Template>
    </Plugin>
  );
};

export { ToolbarDelete };
